import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { CaracteristicasApto } from "../interfaces/CaracteristicasApto";

export const cadastrarCaracteristicasAptoService = async (
  values: Partial<CaracteristicasApto>
) => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/caracteristicas-apto`;

    try {
      const response = await axios.post(URL, values, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};
